import styled from "styled-components";

import * as colors from "src/styles/constants/colors";
import * as size from "src/styles/constants/size";

export const FieldLabel = styled.span`
  font-weight: bold;
  font-size: ${size.fontSize.large};
`;

export const Field = styled.div<{ form?: boolean; invertBackground?: boolean }>`
  background-color: ${(props) =>
    props.invertBackground ? colors.currentUserHighlight : colors.brightLight};
  display: flex;
  flex-direction: column;
  gap: ${({ form }) => (form ? "4px" : "6px")};
  padding: ${({ form }) => (form ? "0" : "8px")};
  border-radius: 4px;
`;

export const ChecklistContent = styled.div<{ isReply?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${(props) =>
    props.isReply &&
    `
    background-color: ${colors.currentUserHighlight};
    border-radius: 4px;
  `}
`;
